import React, { useEffect } from 'react';
import styles from './MfImportFile.module.css';
import { useMfImport } from 'features/compositions/context/MfImportContext';
import MfSourcePicker from './MfSourcePicker';
import { useParseMf } from 'features/compositions/services/useMfImportService';
import ActionLoader from 'components/shared/status/ActionLoader';
import ActionFailed from 'components/shared/status/ActionFailed';

/**
 * Prvi korak čarobnjaka.
 *
 * Izbor izvora je izdvojen u `MfSourcePicker`, koji ga gradi iz kataloga
 * (`GET /api/imports/`) umesto iz ukucane liste ekstenzija. Ovde ostaje samo
 * ono što se tiče toka: pokreni čitanje strukture, prikaži stanje, pređi na
 * korak 2 kad struktura stigne.
 */
const MfImportFile = () => {
    const { setStep } = useMfImport();

    const {
        response,
        loading,
        error,
        parseMf,
        resetServerStatus,
    } = useParseMf();

    useEffect(() => {
        if (response?.status) {
            setStep(2);
        }
    }, [response?.status, setStep]);

    useEffect(() => {
        if (response) {
            const timer = setTimeout(() => {
                resetServerStatus();
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [response, resetServerStatus]);
    

    return (
        <div className={styles.mf_import_file_step}>
            {loading && <ActionLoader text="Reading the source and inferring its structure..." />}
            {error && <ActionFailed text={error} />}
            <MfSourcePicker
                loading={loading}
                onSubmit={({ slug, file, config }) => {
                    resetServerStatus();
                    parseMf({ slug, file, config });
                }}
            />
        </div>
    );
};

export default MfImportFile;
